import { useEffect, useState } from "react";
import { Play, Pause, ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import { FadeUp, Eyebrow } from "../components/Reveal";

export default function Releases() {
  const [releases, setReleases] = useState([]);
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    api.get("/releases").then((r) => setReleases(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-obsidian text-white min-h-screen grain relative">
      <section className="pt-24 pb-24 lg:pt-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <FadeUp>
            <Eyebrow dark>The Catalogue</Eyebrow>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 tracking-tight">
              Records that left <span className="italic gold-gradient-text">the room</span>
            </h1>
            <p className="text-white/50 mt-6 max-w-xl text-base leading-relaxed">
              A selection of projects recorded, mixed or mastered by Empress. Press play, then hear them in full on your platform of choice.
            </p>
          </FadeUp>

          <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {releases.map((r, i) => (
              <FadeUp key={r.release_id} delay={(i % 3) * 0.1} className="rounded-3xl bg-[#18171E] border border-white/8 p-5 group" data-testid={`release-card-${i}`}>
                <div className="relative rounded-2xl overflow-hidden aspect-square">
                  <img src={r.artwork_url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${r.artwork_url}` : r.artwork_url} alt={`${r.title} artwork`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <button
                    onClick={() => setPlaying(playing === r.release_id ? null : r.release_id)}
                    data-testid={`release-play-${i}`}
                    aria-label={`Play preview of ${r.title}`}
                    className="absolute inset-0 flex items-center justify-center bg-obsidian/0 hover:bg-obsidian/40 transition-colors"
                  >
                    <span className="w-14 h-14 rounded-full bg-gold text-obsidian flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-xl">
                      {playing === r.release_id ? <Pause size={20} /> : <Play size={20} className="ml-0.5" />}
                    </span>
                  </button>
                  {playing === r.release_id && (
                    <div className="absolute bottom-3 left-3 flex items-end gap-[3px] h-4">
                      {[0, 1, 2, 3].map((b) => (
                        <span key={b} className="eq-bar w-[3px] h-4 bg-gold rounded-full" style={{ animationDelay: `${b * 0.13}s` }} />
                      ))}
                    </div>
                  )}
                </div>
                <div className="pt-5 flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-serif text-xl">{r.title}</h3>
                    <p className="text-sm text-white/50 mt-1">{r.artist} · {r.year}</p>
                  </div>
                  <a href={r.stream_url} target="_blank" rel="noreferrer" data-testid={`release-stream-${i}`}
                     className="flex items-center gap-1 text-[11px] font-mono uppercase tracking-widest text-purple-300 border border-white/15 rounded-full px-3 py-1.5 hover:border-gold hover:text-gold transition-colors shrink-0">
                    {r.platform} <ArrowUpRight size={11} />
                  </a>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
